module.exports = __webpack_public_path__ + "static/media/hen@2x.6ccd63e9.jpg";